import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import { useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";

const TablaLoteInventario = ({ loteInventarios, productId, loteId, handleEditarLoteInventarioEspecífico, handleActualizarEstadoLoteInventario }) => {
    const tableRef = useRef();

    useEffect(() => {
        if (!loteInventarios || loteInventarios.length === 0) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
                $(tableRef.current).empty();
            }
            return;
        }

        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
            $(tableRef.current).empty();
        }

        const table = $(tableRef.current).DataTable({
            data: loteInventarios,
            columns: [
                { targets: 0, title: "Id", data: "id" },
                { targets: 1, title: "Tipo Inventario", data: "inventarioTipo.nombre" },
                { targets: 2, title: "Existencia", data: "existencia" },
                {
                    targets: 3,
                    title: "Estado",
                    data: "estado",
                    render: (data) => {
                        return `<span class="badge ${data === "Activo" ? "badge-success" : "badge-danger"
                            }">${data}</span>`;
                    },
                },
            ],
            paging: true,
            lengthChange: false,
            ordering: true,
            searching: false,
            info: true,
            autoWidth: true,
            responsive: true,
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                infoPostFix: "",
                thousands: ",",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "Sin resultados encontrados",
                paginate: {
                    first: "|<<",
                    last: ">>|",
                    next: ">>",
                    previous: "<<",
                },
            },
            destroy: true,
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
        };
    }, [loteInventarios, productId, loteId, handleEditarLoteInventarioEspecífico, handleActualizarEstadoLoteInventario]);

    return (
        <div className="p-3 mb-2 bg-light border-left border-secondary rounded">
            <h6 className="mb-2 text-primary">Inventarios Asignados al Lote:</h6>
            <table
                ref={tableRef}
                className="table table-sm table-bordered tabla-lote-inventarios-detalles"
                style={{ width: "100%" }}
            ></table>
        </div>
    );
};

export default TablaLoteInventario;